import React, { useMemo } from 'react'
import {
  Box,
  Text,
  useResponsiveWrapperContext,
} from '@usap/uicomponents'

const Information = props => {
  const {
    title,
    message,
    borderColor = '#2E4787',
    bgColor = 'white',
    textAlign = 'left',
    fontSize = '16px',
    textColor = '',
  } = props

  const { isDesktop } = useResponsiveWrapperContext()

  const style = useMemo(
    () => ({
      wrapper: {
        width: '100%',
        marginBottom: '8px',
        borderColor,
        borderStyle: 'solid',
        borderWidth: '0 0 0 4px',
      },
      wrapperMargin: {
        vertical: 'xxxsmall',
        horizontal: 'auto',
      },
      wrapperBackground: {
        color: bgColor,
      },
      container: {
        borderColor: '#E0E0E0',
        borderStyle: 'solid',
        borderWidth: '1px 1px 1px 0',
        padding: '0 15px',
      },
      containerPad: {
        vertical: 'small',
      },
      header: {
        color: textColor,
        fontSize,
        marginTop: '10px',
        textAlign,
      },
      body: {
        fontSize: '14px',
        fontWeight: 'normal',
        lineHeight: isDesktop ? '19px' : 'normal',
        paddingBottom: '10px',
        textAlign,
      },
    }),
    [
      isDesktop,
      borderColor,
      bgColor,
      textAlign,
      fontSize,
      textColor,
    ],
  )

  return (
    <Box
      direction="column"
      margin={style.wrapperMargin}
      style={style.wrapper}
      background={style.wrapperBackground}
    >
      <Box
        align="center"
        pad={style.containerPad}
        style={style.container}
      >
        <Box width="100%">
          <Text
            as="strong"
            height="21px"
            style={style.header}
          >
            {title}
          </Text>
        </Box>
        <Box width="100%">
          <Text style={style.body}>
            {message}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}

export default Information
